<template lang="html">
    <!-- card style on singles  -->
    <v-card class="single-card elevation-0">
        <v-card-title v-if="title">{{ title }}</v-card-title>

        <v-card-text>
            <slot name="content"></slot>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            title: {
                required: false
            }
        },

        methods: {
            setLabelWidth() {
                // calculate the label width of fields inside a card
                // goal => align labels in cols, with the data-group
                // ex data_group = 1 :  col 1 etc ...
                // and calcultae the number of col to set the size of a field  
                let groups = [];

                Object.entries(this.$el.getElementsByClassName('field')).forEach((entry) => {
                    let el      = entry[1]
                    let groupId = el.attributes['data-group'].value

                    if(!groups.filter(o => o.group == groupId).length) {
                        groups.push({ group: groupId, width: 0 })
                    }

                    if(el.getElementsByClassName('label') && el.getElementsByClassName('label')[0]) {
                        let labelWidth = el.getElementsByClassName('label')[0].clientWidth
                        if(labelWidth > groups.filter(o => o.group == groupId)[0].width) {
                            groups.filter(o => o.group == groupId)[0].width = labelWidth
                        }
                    }
                })

                Object.entries(this.$el.getElementsByClassName('field')).forEach((entry) => {
                    let el          = entry[1]
                    let groupId     = el.attributes['data-group'].value
                    let groupWidth  = groups.filter(o => o.group == groupId)[0].width
                    if(el.getElementsByClassName('label') && el.getElementsByClassName('label')[0]) {
                        let labelWidth  = el.getElementsByClassName('label')[0].clientWidth

                        if(labelWidth < groupWidth) {
                            el.getElementsByClassName('label')[0].style.width = groupWidth + 'px'
                        }
                    }
                })
            }
        },

        mounted() {
            this.setLabelWidth()
        }
    }
</script>

<style lang="stylus" scoped>
    @require '../../assets/css/variables'

    div.single-card {
        margin: 0 0 3rem

        .card__title {
            font-weight: 600
            color: $text-color
            font-size: 1.7rem
            border-bottom: 1px solid $border-light-color
        }

        .card__text {
            padding: 2rem 3.5rem 4rem

            & >>> .align-center {
                align-self: center
            }

            & >>> div.subtitle {
                margin: 2rem 0
                font-weight: 700
                color: $text-color
                font-size: 1.5rem

                &--top { margin-top: 0 }
            }

            & >>> div.field {
                display: flex
                padding: 0 0 0.5rem
                justify-content: flex-start
				flex-direction: row
				align-items: center
				min-height: 5.5rem

                div.label {
                    padding: 0 0.5rem 0 0
                    font-weight: 600
                    font-size: 1.5rem
                    color: $label-color
                    text-align: left
                    flex: 0.5
                }

                &.top {
                    align-items: flex-start

                    div.label {
                        padding-top: 0.5rem
                    }
                }

                div.value {
                    flex: 1
                    font-size: 1.5rem

                    &.area {
                        position: relative
                        padding: 0.5rem
                        min-height: 3rem

                        .icon {
                            transition: opacity ease-out 300ms
                            position: absolute
                            top: 50%
                            right: 0.5rem
                            color: #ABB4D0
                            font-size: 1.6rem
                            opacity: 0
                            transform: translateY(-50%)
                        }

                        &:not(.readonly) {
                            &:hover {
                                cursor: pointer
                                background-color: $app-content-background

                                .icon {
                                    opacity: 1
                                }
                            }
                        }
                    }
                }
            }
        }


        &.single-header {
            padding-top: 5rem

            & >>> * {

                div.framed {
                    margin: 0 -3.5rem
                    //padding: 0.5rem 3.5rem 0
                    padding: 0 3.5rem
                    background-color: #f9fbfd
                    border-top: 0.1rem solid #e7e9f1
                    border-bottom: 0.1rem solid #e7e9f1

                    div.field {
                        padding: 0.8rem 0

                        div.value {
                            color: #737779
                        }
                    }
                }

                div.avatar-col {
                    flex: none
                    margin: 0 6rem 0 0
                }

                h1 {
                    display: flex
                    align-items: center
                    margin: 0 0 0.2rem
                    color: $title-color
                    font-weight: 300
                    font-size: 4.5rem

                    span {
                        margin: 0 0 0 1.5rem
                        font-size: 2.5rem
                        transform: translateY(0.3rem)
                    }
                }

                div.counters {
                    margin: 0 0 2rem

                    span {
                        margin: 0 2rem 0 0
                        font-size: 1.6rem

                        .icon {
                            font-size: 1.8rem
                        }
                    }
                }

                div.field {
                    div.label {
                        padding: 0 1rem 0 0
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/single/SingleCard.vue